import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import "../Print.css";

type SalesDataProps = {
  salesData: {
    net_sales: number;
    sales_vat: number;
    gross_sales: number;
    sales_discount: number;
  };
  source: string;
};

export const SalesSummary: FunctionComponent<SalesDataProps> = ({
  salesData,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "1.3em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Sales Summary</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Gross Sales
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData?.gross_sales ? salesData.gross_sales : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Discounts
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData?.sales_discount
                    ? salesData.sales_discount
                    : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Vat Collected
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData?.sales_vat ? salesData.sales_vat : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Net Sales
                </TableCell>
                <TableCell className={classes.headCell} align="right">
                  {salesData?.net_sales ? salesData.net_sales : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
